import React from "react";
import { Notification } from "../../../_app/types";
import NotificationCard from "./NotificationCard";
import { Stack } from "@mui/material";

interface Props {
  messages: Notification[];
}

const NotificationListRender = ({ messages }: Props) => {
  return (
    <Stack direction={"column"} spacing={1}>
      {messages.map((notification, index) => (
        <NotificationCard key={index + "_" + notification.eventTime} notification={notification} />
      ))}
    </Stack>
  );
};

export default NotificationListRender;
